import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import Store from 'store/store';
import { smoothScrollTo } from 'utils/smoothScroll';
import { animation } from 'utils/bolt/transitions';

export default class Header extends BaseComp.default {
	async triggerPersistentButton(path, label) {
		Store.emit('HEADER_PERSISTENT_BUTTON_CLICK', 'header-button-click', 'header', label, {}, path);
		if (!path) {
			return;
		}
		const mainScroll = document.getElementById('mainScroll');
		const logo = label.toLowerCase() === 'logo';
		let pageData = this.props.appData?.pages?.[this.props.activePage];
		const hasHubPage = this.props.appData.pages['boltHubPage'];
		const isRootPath = pageData?.path === '/';
		const isSection = pageData?.section;
		smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
		if (isRootPath && logo) {
			return smoothScrollTo(document.getElementById('mainScroll'), 0, 300);
		}
		if (!isSection) {
			if (hasHubPage) {
				await animation(mainScroll, logo ? 'right' : 'left', 400);
			}
		}
		return Store.emit('CLOSE_AND_NAVIGATE', path, '', { instant: false });
	}
}
